import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';
import Badge from './Badge';

/** ServiceTile — icon + title + short description. Non-interactive when comingSoon. */
export default function ServiceTile({ icon, title, desc, to, href, comingSoon = false, soonLabel = 'Coming Soon', className = '' }) {
  const cls = `service-tile${comingSoon ? ' is-soon' : ''}${className ? ` ${className}` : ''}`;
  const inner = (
    <>
      <span className="service-tile__icon"><Icon name={icon} size={24} /></span>
      <span className="service-tile__text">
        <span className="service-tile__title">{title}</span>
        {desc && <span className="service-tile__desc">{desc}</span>}
        {comingSoon && <Badge variant="muted" className="service-tile__soon">{soonLabel}</Badge>}
      </span>
    </>
  );
  if (comingSoon || (!to && !href)) return <div className={cls} aria-disabled={comingSoon || undefined}>{inner}</div>;
  if (href) return <a href={href} className={cls} target="_blank" rel="noopener noreferrer">{inner}</a>;
  return <Link to={to} className={cls}>{inner}</Link>;
}
